var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import InputComponent from "@frameworks/NCD/Components/InputComponent";
import { ESubProductIds } from "@frameworks/shared-library/components/Orderbook/common/OrderbookConstants";
import { floatNumExp } from "@frameworks/web/utils/regex";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import actions from "@redux/feature/Markets/NCD/actions/TransactionJourneyActions";
import ToastModal from "@frameworks/pmsjourney/components/common/toast";
import useSetUpFeeAmount from "@frameworks/NCD/Hook/TransactionJourney/useSetUpFeeAmount";
export var SetupFee = function (_a) {
    var _b, _c;
    var subCategoryId = _a.subCategoryId;
    var cActions = new actions();
    var _d = __read(useState(false), 2), isChecked = _d[0], setChecked = _d[1];
    var _e = __read(useState(false), 2), inValid = _e[0], setInValid = _e[1];
    var _f = useSetUpFeeAmount();
    var _g = useSelector(function (state) { return state.markets.Otc.transactionJourneyReducer; }), purchaseFee = _g.purchaseFee, transactionId = _g.transactionId, transactionJourney = _g.transactionJourney, validateSetUpFees = _g.validateSetUpFees;
    var _h = __read(useState(""), 2), message = _h[0], setMessage = _h[1];
    var _j = __read(useState(false), 2), visible = _j[0], setVisible = _j[1];
    var handleCheckboxChange = function (e) {
        var isChecked = e.target.checked;
        if (transactionId > 0 && (transactionJourney === null || transactionJourney === void 0 ? void 0 : transactionJourney.quantity)) {
            setChecked(isChecked);
            if (isChecked) {
                cActions.updateValidSetUpFess(true);
            }
            else {
                cActions.updateTransactionFeeValueProp(__assign(__assign({}, purchaseFee), { setUpFees: null }));
                setInValid(false);
            }
        }
        else {
            setVisible(true);
            setMessage("You can select setup fee only after entering the quantity ".concat(!(transactionJourney === null || transactionJourney === void 0 ? void 0 : transactionJourney.dirtyPrice) ? "and Dirty Price." : "."));
            return;
        }
    };
    var handleOnChangeInputs = function (value) {
        var _a;
        if (value.length <= 8) {
            cActions.updateTransactionFeeValueProp(__assign(__assign({}, purchaseFee), { setUpFees: value }));
            cActions.updateValidSetUpFess(false);
            if (((_a = validateSetUpFees === null || validateSetUpFees === void 0 ? void 0 : validateSetUpFees.data) === null || _a === void 0 ? void 0 : _a.max_setupfee_amt) >= Number(value)) {
                setInValid(false);
            }
            else {
                setInValid(true);
            }
        }
    };
    if (subCategoryId !== ESubProductIds.StructuredProducts)
        return null;
    useEffect(function () {
        if (purchaseFee === null || purchaseFee === void 0 ? void 0 : purchaseFee.setUpFees) {
            setChecked(true);
        }
    }, [purchaseFee === null || purchaseFee === void 0 ? void 0 : purchaseFee.setUpFees]);
    useEffect(function () {
        if (transactionId < 1 || !(transactionJourney === null || transactionJourney === void 0 ? void 0 : transactionJourney.quantity)) {
            setChecked(false);
        }
    }, [transactionJourney === null || transactionJourney === void 0 ? void 0 : transactionJourney.quantity]);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "d-flex flex-column gap-2" },
            React.createElement("div", { className: "otc-transaction-flow d-flex  align-items-center" },
                React.createElement("div", { className: "d-flex align-items-start fund-checkbox common-checkbox-custom small-checkbox" },
                    React.createElement("input", { type: "checkbox", checked: isChecked, onChange: handleCheckboxChange })),
                React.createElement("div", { className: "d-flex align-items-center gap-1" },
                    React.createElement("span", { className: "DMSanN_14_400 txt_blackOne1" }, "Set Up Fees Amount"),
                    React.createElement("span", { className: "DMSanN_14_400 txt_whispering-periwinkle d-flex align-items-center gap-1" },
                        React.createElement("span", null, "(Optional)")))),
            isChecked && (React.createElement(InputComponent, { label: "", placeholder: "Enter Setup Fees here", required: true, integer: true, isInvalid: inValid, helperText: "(".concat((_b = validateSetUpFees === null || validateSetUpFees === void 0 ? void 0 : validateSetUpFees.data) === null || _b === void 0 ? void 0 : _b.min_setupfee_amt, " - ").concat((_c = validateSetUpFees === null || validateSetUpFees === void 0 ? void 0 : validateSetUpFees.data) === null || _c === void 0 ? void 0 : _c.max_setupfee_amt, " price allowed to be entered)"), name: "amount", min: 1, max: 8, float: floatNumExp(2), onChangeEvent: function (event) { return handleOnChangeInputs(event.target.value); }, value: purchaseFee.setUpFees }))),
        React.createElement(ToastModal, { visible: visible, setVisible: setVisible, message: message, isError: true })));
};
